"use client";

import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useMessaging } from "@/providers/messaging-provider";
import { cn } from "@/lib/utils";
import { MobileMessengerSheet } from "./MobileMessengerSheet";

export function MobileMessengerFAB() {
  const [isOpen, setIsOpen] = useState(false);
  const { state } = useMessaging();

  // Calculate total unread count
  const unreadCount = state.conversations.reduce(
    (count, conv) => count + (conv.unreadCount || 0),
    0
  );

  return (
    <>
      {/* FAB Button - only visible on mobile (hidden on md: and above) */}
      <Button
        onClick={() => setIsOpen(true)}
        className={cn(
          "fixed bottom-20 right-4 z-40 h-14 w-14 rounded-full shadow-lg",
          "bg-green-600 hover:bg-green-700 text-white",
          "md:hidden", // Hidden on desktop
          "transition-transform hover:scale-105"
        )}
        size="icon"
      >
        <MessageSquare className="h-6 w-6" />
        {unreadCount > 0 && (
          <Badge className="absolute -top-1 -right-1 h-5 min-w-5 flex items-center justify-center bg-red-500 text-white text-xs">
            {unreadCount > 99 ? "99+" : unreadCount}
          </Badge>
        )}
        <span className="sr-only">Open messages</span>
      </Button>

      {/* Bottom Sheet */}
      <MobileMessengerSheet open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
}
